exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4150819a&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TotalPrice.vue
// module id = 353
// module chunks = 0